/**
 * @generated SignedSource<<39703b5da0e9b7b2e028484c1a648034>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNativeSurvey_options$data = {
  readonly options: ReadonlyArray<{
    readonly label: string;
    readonly score: number;
    readonly subValue: string | null | undefined;
    readonly sublabel: string | null | undefined;
    readonly value: string;
  }>;
  readonly " $fragmentType": "useNativeSurvey_options";
};
export type useNativeSurvey_options$key = {
  readonly " $data"?: useNativeSurvey_options$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNativeSurvey_options">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNativeSurvey_options",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Option",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sublabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "e6134058efcc38443589cc5ce833c145";

export default node;
